import { render, staticRenderFns } from "./FormFilters.vue?vue&type=template&id=2afd6ddb"
import script from "./FormFilters.vue?vue&type=script&lang=js"
export * from "./FormFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports